import { render, staticRenderFns } from "./WidgetsRender.vue?vue&type=template&id=87b000ca&scoped=true"
import script from "./WidgetsRender.vue?vue&type=script&lang=js"
export * from "./WidgetsRender.vue?vue&type=script&lang=js"
import style0 from "./WidgetsRender.vue?vue&type=style&index=0&id=87b000ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b000ca",
  null
  
)

export default component.exports